<template>
  <div v-if="menu.SpecialCategories" class="row">
    <div class="col-sm-12">
      <div class="row">
        <div id="combos" class="category-title">{{ $t('message.giftCards') }}</div>
      </div>

      <!-- combos category -->
      <div v-if="menu.SpecialCategories" class="gft-pr-spc">
        <section>
          <div
            v-for="product in validProducts"
            :key="product.ID"
            class="row"
          >
            <Product
              :product="menu.Products[product.ProductID]"
              :category="product"
              :key="product.ID"
            />
          </div>
          <br />
        </section>
      </div>
      <div v-else>
        <message />
      </div>
    </div>
  </div>
</template>

<script>
import Product from "./GiftProductMobile";

import Message from "../../shared/Message";
export default {
  name: "ProductList",
  components: { Product, Message },
  props: {
    menu: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    validProducts() {
      let temp = [];
      this.menu.SpecialCategories.SCTypeGiftcard.SubMenuItems.forEach(
        (element) => {
          if (this.menu.Products[element.ProductID]) {
            temp.push(element);
          }
        }
      );
      return temp;
    },
  },
};
</script>
